module.exports = "<div id=\"coachmarkBackground\" *ngIf=\"show\"></div>\r\n<div id=\"coachmarkTips\" >\r\n    <span *ngIf=\"show\" id=\"coachmarkTipsText\" [innerHTML]=\"'Select devices that you have and <br> characterize them in detail.' | translate\"></span><br>\r\n    <input *ngIf=\"show\" id=\"gotItBtn\" class=\"fowardBtn\" type=\"submit\" [value]=\"('GOT IT!' | translate)\" (click)=\"gotIt()\" ><br>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/coachmarks/coachmark-house-detail/coachmark-house-detail.component.html
// module id = ./src/app/shared/components/coachmarks/coachmark-house-detail/coachmark-house-detail.component.html
// module chunks = main